import { Box, Grid2, Paper } from "@mui/material"
import { Background } from "./styles"
import { Button, Input } from "../../components"
import { useAuthContext } from "../../hooks"
import { useFormik } from "formik"
import { LoginSchema } from "@milespay.co/validations"
import { useNavigate } from "react-router-dom"

export const LoginPage = () => {
    const navigate = useNavigate()
    const {signIn} = useAuthContext()

  const formik = useFormik({
    initialValues: {
        email: '',
        password: ''
    },
    validationSchema: LoginSchema,
    validateOnMount: false,
    onSubmit: async (values) => {
        console.log('values', values)
        const loggedIn = await signIn(values)
        console.log('loggedIn', loggedIn)

        if (loggedIn) {
          navigate('/')
        }
    }
  })

    return (
        <Background>
            <Paper style={{width: '25vw'}}>
                <Box> 
                    <form onSubmit={formik.handleSubmit}>
                        <Grid2 container p={2} spacing={1}>
                            <Grid2>
                                <img src="/assets/logo.png" alt="Milespay Logo" width={"100%"} />
                            </Grid2>
                            <Grid2 size={{xs: 12}}>
                                <Input 
                                    label="E-mail" 
                                    type="email"
                                    name="email"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    helperText={formik.touched.email && formik.errors.email}
                                    error={formik.touched.email &&!!formik.errors.email} 
                                />
                            </Grid2>
                            <Grid2 size={{xs: 12}}>
                                <Input 
                                    label="Senha" 
                                    type="password"
                                    name="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    helperText={formik.touched.password && formik.errors.password}
                                    error={formik.touched.password && !!formik.errors.password} 
                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12 }} mt={1} textAlign={"center"}>
                                <Button type="submit">
                                    ENTRAR
                                </Button>
                            </Grid2>
                        </Grid2>
                    </form>
                </Box>  
            </Paper>
        </Background>
    )
}